<template>
  <div>
    <div class="layout-padding">
      <div class="row justify-end q-mb-sm-none q-mb-md">
        <q-select
          hide-underline
          inverted-light
          color="white"
          class="project__mode-dropdown"
          :options="typeFilterOptions"
          :value="typeFilter"
          @change="handleTypeFilterChanged"
        />
      </div>

      <template v-if="projects.length || isTemporaryResult">
        <q-infinite-scroll ref="infiniteScroll" :handler="handleFetchNextChunk">
          <div v-for="(group, index) in groupedProjects" :key="index" class="q-mb-xl">
            <div class="q-headline text-bold text-blue-grey-4 q-mb-sm">{{ group.group }}</div>

            <div class="row gutter-md">
              <div v-for="project in group.values" :key="project.id" class="col-xs-12 col-md-6 col-xl-4">
                <project-card :project="project"/>
              </div>
            </div>
          </div>
        </q-infinite-scroll>
      </template>

      <template v-if="showEmptyState">
        <div class="row justify-center items-center col-grow q-pt-lg">
          <div class="text-center">
            <img src="~assets/emptystates/projects_empty.svg"/>

            <h6 class="q-my-md text-faded">{{ $t('projects_empty') }}</h6>

            <q-btn @click="handleCreateProject" color="primary" class="q-mt-lg" outline>
              {{ $t('create_project') }}
            </q-btn>
          </div>
        </div>
      </template>
    </div>

    <q-page-sticky position="bottom-right" :offset="[18, 18]">
      <q-btn
        @click="handleCreateProject"
        color="primary"
        round
        fab
        v-is-user
      >
        <q-icon name="add"/>
      </q-btn>
    </q-page-sticky>

    <project-modal ref="createProjectModal" @save="handleSaveProject"/>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import ProjectCard from 'components/TimeTracking/Projects/ProjectCard.vue'
  import ProjectModal from 'components/TimeTracking/Projects/ProjectModal.vue'
  import changeCase from 'change-case-object'
  import { createErrorFromResponse } from 'src/utils/error'
  import { groupBy } from 'src/utils/array'
  import { orderBy } from 'lodash'
  import store from 'src/store'

  export default {
    data () {
      return {
        selectedProjects: [],
        typeFilter: 'active',
        isTemporaryResult: false,
        pagination: {
          page: 1,
          rowsNumber: 0,
          rowsPerPage: 15,
          descending: true,
          sortBy: 'created_at'
        }
      }
    },

    computed: {
      ...mapGetters(['projects', 'projectsLoaded', 'activeTeam']),

      typeFilterOptions () {
        return [
          {
            value: 'active',
            label: this.$t('project_status_filter.active')
          },
          {
            value: 'inactive',
            label: this.$t('project_status_filter.inactive')
          }
        ]
      },

      showActiveProjects () {
        return this.typeFilter === 'active'
      },

      groupedProjects () {
        return orderBy(groupBy(this.projects, project => project.name.charAt(0).toUpperCase()), 'group', 'asc')
      },

      showEmptyState () {
        return (this.projects.length === 0 && !this.isTemporaryResult) || (this.type === 'grid' && this.projects.length === 0)
      }
    },

    methods: {
      ...mapActions(['listProjects', 'fetchNextProjectsChunk', 'createProject']),

      handleCreateProject () {
        this.$refs.createProjectModal.show()
      },

      handleSaveProject (project) {
        return this.createProject(changeCase.snake(project))
          .then(project => {
            this.$router.push({ name: 'project', params: { team: this.activeTeam.id, project: project.id } })
          })
          .catch(createErrorFromResponse)
      },

      handleFetchNextChunk (index, done) {
        this.fetchNextProjectsChunk({
          done: done,
          pagination: {
            sortBy: 'name',
            descending: false,
            include: [
              'customer',
              'statistics'
            ],
            filterBy: [
              ['active', '=', this.showActiveProjects ? 'true' : 'false']
            ]
          }
        })
      },

      handleTypeFilterChanged (newValue) {
        this.typeFilter = newValue

        this.listProjects({
          pagination: {
            sortBy: 'name',
            descending: false,
            include: [
              'customer',
              'statistics'
            ],
            filterBy: [
              ['active', '=', this.showActiveProjects ? 'true' : 'false']
            ]
          }
        })
          .then(() => {
            this.$nextTick(() => {
              this.$refs.infiniteScroll.reset()
              this.$refs.infiniteScroll.resume()
            })
          })
      }
    },

    beforeRouteEnter (to, from, next) {
      store.dispatch('listProjects', {
        pagination: {
          sortBy: 'name',
          descending: false,
          include: [
            'customer',
            'statistics'
          ],
          filterBy: [
            ['active', '=', 'true']
          ]
        }
      })
        .then(next)
    },

    components: {
      ProjectCard,
      ProjectModal
    }
  }
</script>
